const FixedMenu = {
	body: null,
	scrollThreshold: 100,

	init() {
		this.body = document.body;
		if (!this.body) {
			return;
		}

		// Bind the context of `this` for the event handler.
		this.handleScroll = this.handleScroll.bind(this);

		// Run on load in case the page is already scrolled.
		this.handleScroll();

		window.addEventListener("scroll", this.handleScroll, { passive: true });
	},

	handleScroll() {
		if (window.pageYOffset > this.scrollThreshold) {
			this.body.classList.add("fixed-menu");
		} else {
			this.body.classList.remove("fixed-menu");
		}
	},
};

export default FixedMenu;